export default "__VITE_ASSET__BVi_LWjY__"